<tui-root [class]="['app-fullscreen', theme()]">
	<main>
		<router-outlet />
	</main>
</tui-root>
